import { MultiangebotAdressenValidationResult } from '@ps20-frontend/frontend-models';
import { Role } from '@ps20/bff-models';
import { IAppState } from '../../../store/appState';

export const selectZurueckZumShopOpen = (state: IAppState): boolean =>
  state.transientState.zurueckZumShopModalOpen;

export const selectTarifierungIsInProgress = (state: IAppState): boolean =>
  state.transientState.tarifierungIsInProgress;
export const selectAdressvorschlagIsInProgress = (state: IAppState): boolean =>
  state.transientState.adressvorschlagIsInProgress;

export const selectVwgVorhandenError = (state: IAppState): MultiangebotAdressenValidationResult =>
  state.transientState.vwgVorhandenError;

export const selectMapViewModalOpen = (state: IAppState): boolean =>
  state.transientState.mapViewModal.isOpen;

export const selectMapViewModalAdresseTarifierbar = (state: IAppState): boolean =>
  state.transientState.mapViewModal.isAdresseTarifierbar;


export const showZumAngebotLoadingSpinner = (state: IAppState): boolean =>
  state.transientState.showZumAngebotLoadingSpinner;

export const selectIsAzamUnderwriter = (state: IAppState): boolean =>
  state.transientState.role === Role.UWPSHRK;
